<template>
  <div>
    <!-- Informações Gerais -->
    <CCard class="mb-3">
      <CCardHeader class="section-header">
        <fa-icon icon="info-circle" class="mr-2" />
        <strong>Informações Gerais</strong>
      </CCardHeader>
      <CCardBody>
        <div class="row">
          <div class="col-md-4">
            <div class="info-item">
              <label>
                <fa-icon icon="hashtag" class="mr-1 text-muted" />
                ID
              </label>
              <div class="info-value">
                <CBadge color="primary" size="lg">{{ orcamento.id }}</CBadge>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info-item">
              <label>
                <fa-icon icon="flag" class="mr-1 text-muted" />
                Situação
              </label>
              <div class="info-value">
                <SituacaoOrcamento :situacao="orcamento.situacao" />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info-item">
              <label>
                <fa-icon icon="cogs" class="mr-1 text-muted" />
                Operação
              </label>
              <div class="info-value">{{ orcamento.operacao_id || 'N/D' }}</div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- Datas -->
    <CCard class="mb-3">
      <CCardHeader class="section-header">
        <fa-icon icon="calendar-alt" class="mr-2" />
        <strong>Datas</strong>
      </CCardHeader>
      <CCardBody>
        <div class="row">
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="plus-circle" class="mr-1 text-muted" />
                Data de Criação
              </label>
              <div class="info-value">{{ orcamento.datahorainclusao | datetime }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="edit" class="mr-1 text-muted" />
                Última Atualização
              </label>
              <div class="info-value">{{ orcamento.dataatualizacao | datetime }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="sync" class="mr-1 text-muted" />
                Data de Integração
              </label>
              <div class="info-value">{{ orcamento.datahoraintegracao | datetime }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="truck" class="mr-1 text-muted" />
                Data de Entrega
              </label>
              <div class="info-value">{{ orcamento.dataentrega | date }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="clock" class="mr-1 text-muted" />
                Data de Validade
              </label>
              <div class="info-value">{{ orcamento.datavalidade | date }}</div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- Sistemas e Integração -->
    <CCard class="mb-3">
      <CCardHeader class="section-header">
        <fa-icon icon="network-wired" class="mr-2" />
        <strong>Sistemas e Integração</strong>
      </CCardHeader>
      <CCardBody>
        <div class="row">
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="arrow-circle-right" class="mr-1 text-muted" />
                Sistema de Origem
              </label>
              <div class="info-value">
                <CBadge color="info">{{ orcamento.plataforma_inicial || 'N/D' }}</CBadge>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-item">
              <label>
                <fa-icon icon="arrow-circle-left" class="mr-1 text-muted" />
                Sistema de Transmissão
              </label>
              <div class="info-value">
                <CBadge color="info">{{ orcamento.plataforma_final || 'N/D' }}</CBadge>
              </div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- Pagamento -->
    <CCard class="mb-3">
      <CCardHeader class="section-header">
        <fa-icon icon="credit-card" class="mr-2" />
        <strong>Pagamento</strong>
      </CCardHeader>
      <CCardBody>
        <div class="row">
          <div class="col-md-6" v-if="orcamento.cobranca">
            <div class="info-item">
              <label>
                <fa-icon icon="file-invoice-dollar" class="mr-1 text-muted" />
                Cobrança
              </label>
              <div class="info-value">
                <CBadge color="secondary">{{ orcamento.cobranca.id }}</CBadge>
                - {{ orcamento.cobranca.desc }}
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="orcamento.plano">
            <div class="info-item">
              <label>
                <fa-icon icon="calendar-check" class="mr-1 text-muted" />
                Plano de Pagamento
              </label>
              <div class="info-value">
                <CBadge color="secondary">{{ orcamento.plano.id }}</CBadge>
                - {{ orcamento.plano.desc }}
              </div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- Cliente e Colaborador -->
    <CCard class="mb-3">
      <CCardHeader class="section-header">
        <fa-icon icon="users" class="mr-2" />
        <strong>Cliente e Responsáveis</strong>
      </CCardHeader>
      <CCardBody>
        <div class="row">
          <div class="col-md-6" v-if="orcamento.cliente">
            <div class="info-item">
              <label>
                <fa-icon icon="user" class="mr-1 text-muted" />
                Cliente
              </label>
              <div class="info-value">
                <div><strong>{{ orcamento.cliente.nome || orcamento.cliente.razao }}</strong></div>
                <div class="text-muted small" v-if="orcamento.cliente.cnpj">
                  CNPJ: {{ orcamento.cliente.cnpj }}
                </div>
                <div class="text-muted small" v-if="orcamento.cliente.cpf">
                  CPF: {{ orcamento.cliente.cpf }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="orcamento.colaborador">
            <div class="info-item">
              <label>
                <fa-icon icon="user-tie" class="mr-1 text-muted" />
                Vendedor/Colaborador
              </label>
              <div class="info-value">
                <div><strong>{{ orcamento.colaborador.nome }}</strong></div>
                <div class="text-muted small" v-if="orcamento.colaborador.email">
                  {{ orcamento.colaborador.email }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="orcamento.clienteFinal">
            <div class="info-item">
              <label>
                <fa-icon icon="user-circle" class="mr-1 text-muted" />
                Cliente Final
              </label>
              <div class="info-value">
                <div><strong>{{ orcamento.clienteFinal.nome }}</strong></div>
                <div class="text-muted small" v-if="orcamento.clienteFinal.documento">
                  CPF/CNPJ: {{ orcamento.clienteFinal.documento }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="orcamento.filial">
            <div class="info-item">
              <label>
                <fa-icon icon="building" class="mr-1 text-muted" />
                Filial
              </label>
              <div class="info-value">
                <CBadge color="info">{{ orcamento.filial.id }}</CBadge>
                - {{ orcamento.filial.razao || orcamento.filial.nome }}
              </div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>

    <!-- Informações Adicionais -->
    <CCard class="mb-3">
      <CCardHeader class="section-header">
        <fa-icon icon="info" class="mr-2" />
        <strong>Informações Adicionais</strong>
      </CCardHeader>
      <CCardBody>
        <div class="row">
          <div class="col-md-3">
            <div class="info-item">
              <label>
                <fa-icon icon="edit" class="mr-1 text-muted" />
                Nº de Edições
              </label>
              <div class="info-value">
                <CBadge color="secondary">{{ orcamento.numero_edicao || 0 }}</CBadge>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="info-item">
              <label>
                <fa-icon icon="box" class="mr-1 text-muted" />
                Qt. Itens
              </label>
              <div class="info-value">
                <CBadge color="primary">{{ orcamento.quantidadeitens || 0 }}</CBadge>
              </div>
            </div>
          </div>
          <div class="col-md-3" v-if="orcamento.produto_unico">
            <div class="info-item">
              <label>
                <fa-icon icon="box-open" class="mr-1 text-muted" />
                Produto Único
              </label>
              <div class="info-value">
                <CBadge color="info">Sim</CBadge>
              </div>
            </div>
          </div>
          <div class="col-md-3" v-if="orcamento.duplicado">
            <div class="info-item">
              <label>
                <fa-icon icon="copy" class="mr-1 text-muted" />
                Duplicado
              </label>
              <div class="info-value">
                <CBadge color="warning">Sim</CBadge>
                <div class="text-muted small" v-if="orcamento.pedidoorigem_id">
                  Origem: {{ orcamento.pedidoorigem_id }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3" v-if="orcamento.origem">
            <div class="info-item">
              <label>
                <fa-icon icon="source" class="mr-1 text-muted" />
                Origem
              </label>
              <div class="info-value">
                <CBadge :color="getOrigemColor(orcamento.origem)">
                  {{ orcamento.origem }}
                </CBadge>
              </div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import ChaveValor from "@/components/base/ChaveValor.vue";
import GetValue from "@/components/base/GetValue.vue";
import SituacaoOrcamento from "@/components/base/SituacaoOrcamento.vue";

export default {
  name: "cabecalho-orcamento",
  props: ["orcamento"],
  components: {SituacaoOrcamento, GetValue, ChaveValor },
  methods: {
    getOrigemColor(origem) {
      const colors = {
        'SITE': 'primary',
        'CALLCENTER': 'warning',
        'REPRESENTANTE': 'info',
        'B2B': 'success'
      };
      return colors[origem] || 'secondary';
    }
  }
};
</script>

<style scoped>
/* Section Headers */
.section-header {
  background: #f8f9fa;
  color: #2d3748;
  font-weight: 600;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
}

.section-header .svg-inline--fa {
  color: #6c757d;
  margin-right: 0.5rem;
}

/* Cards */
.card {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

/* Info Items */
.info-item {
  margin-bottom: 1.5rem;
}

.info-item label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 0.9375rem;
  color: #212529;
  padding: 0.5rem 0;
  font-weight: 500;
}

.info-value .text-muted {
  color: #6c757d;
  font-style: normal;
}

/* Utility */
.mr-1 {
  margin-right: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}
</style>
